import setupConsoleFilter, { webpackConsoleFilters } from "functions/Console"

setupConsoleFilter(console, "warn", webpackConsoleFilters)

import("./bootstrap")

export {}
